// Empty string => relative URLs (e.g. "/api/items/"), which nginx proxies to
// the backend. Only set REACT_APP_API_BASE_URL if the backend is on another host.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
